<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @import './assets/styles/custom.css';
  @import './assets/styles/navbar-style.css';
  @import './assets/styles/owl.carousel.min.css';
  @import './assets/styles/owl.theme.default.min.css';
  @import './assets/styles/water-wheel-carousel.css';
</style>



// WEBPACK FOOTER //
// src/App.vue